import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchVtParamMap, setRowIndex } from "../data/actions";
import * as select from "../data/selectors";
import { Grid, Icon, Modal } from "semantic-ui-react";
import { heightSet } from "../../../utilities/heightSet";
import { searchColumns } from "../data/model";
import { TableListDiv } from "../../../utilities/tableListDiv";

const VtParamMapList = (props) => {
  const dispatch = useDispatch();
  const vtParamMap = useSelector((state) => select.getVtParamMapList(state));
  const dataSetOnList = useSelector((state) =>
    select.getDataSetOnOpenEdit(state, props)
  );

  // use for scroll when user back to list from edit
  const [scrollOnEdit, setScrollOnEdit] = useState({
    top: 0,
    status: false,
  });

  const [heights, setHeight] = useState("");
  const [isModalOpen, setIsModalOpen] = useState({
    isOpen: false,
    data: null,
  });

  useEffect(() => {
    dispatch(fetchVtParamMap());
  }, [dispatch]);

  useEffect(() => {
    if (
      dataSetOnList &&
      dataSetOnList !== undefined &&
      dataSetOnList !== null &&
      Object.keys(dataSetOnList).length > 0
    ) {
      setScrollOnEdit({
        top: dataSetOnList.index,
        status: true,
      });
      dispatch(setRowIndex({}));
    }
  }, [dataSetOnList]);

  const callHeightFunc = () => {
    heightSet(setHeight);
  };

  useEffect(() => {
    callHeightFunc();
    window.addEventListener(
      "resize",
      function () {
        callHeightFunc();
      },
      false
    );
    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", callHeightFunc);
    };
  }, []);

  const ActionComponent = ({ object: obj, idx: index }) => {
    const openEdit = (obj, index) => {
      let payload = {
        index: index,
        data: obj,
      };
      dispatch(setRowIndex(payload));
    };
    return (
      <>
        <Link
          to={"/vtparam_map/edit/" + obj.ID}
          onClick={() => {
            openEdit(obj, index);
          }}
          title="Edit"
        >
          <Icon name="edit" color="blue" link />
        </Link>
        <span style={{ color: "#cfd8e3", margin: "0 6px" }}>|</span>
        <Icon
          name="eye"
          color="blue"
          link
          title="View"
          onClick={() => {
            setIsModalOpen({ isOpen: true, data: obj });
          }}
        />
      </>
    );
  };

  return (
    <>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 4px 12px",
      }}>
        <div>
          <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
            VT Param Map
          </div>
          <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
            Manage vehicle type parameter mappings.
          </div>
        </div>
      </div>
      <div style={{ paddingTop: "10px" }}>
        <TableListDiv
          columns={searchColumns}
          data={Object.values(vtParamMap) || []}
          Actions={ActionComponent}
          setHeight={parseFloat(heights) - 200}
          getIndex={6}
          filterBoxNone={""}
          rightBox={""}
          centerBox={""}
          callHeightFunc={callHeightFunc}
          paddingShort={2}
          getWidth={"100%"}
          actionClass={"actionTdDR"}
          scrollOnEdit={scrollOnEdit}
          setScrollOnEdit={setScrollOnEdit}
        />
      </div>
      <Modal
        onClose={() => setIsModalOpen({ isOpen: false, data: null })}
        onOpen={() => setIsModalOpen({ isOpen: true, data: null })}
        open={isModalOpen.isOpen}
        size="small"
        closeIcon
        closeOnDimmerClick
      >
        <Modal.Header>VT Param Map Information</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {isModalOpen.data && isModalOpen.data.param_info}
          </Modal.Description>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default VtParamMapList;
